export type EventKitType = 'applecalendar' | 'applereminders';

export interface EventKitConnectResult {
  success: boolean;
  needsSystemSettings?: boolean;
}

function toNativeType(type: EventKitType): 'calendar' | 'reminders' {
  return type === 'applecalendar' ? 'calendar' : 'reminders';
}

export async function handleEventKitConnect(
  toolkitName: EventKitType
): Promise<EventKitConnectResult> {
  return window.mainProcessApi.connectEventKit(toNativeType(toolkitName));
}

export async function handleOpenEventKitSettings(
  toolkitName: EventKitType
): Promise<{ success: boolean }> {
  return window.mainProcessApi.openEventKitSettings(toNativeType(toolkitName));
}
